import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { LoadingAnimation } from '../../common/components/Utilities';
import DataTable from '../../common/components/DataTable';
import SafeHtml from '../../common/components/SafeHtml';
import Confluence from '../../common/resource/Confluence';
import PeopleLayout from '../layout/PeopleLayout';

function News(props) {
  const { id } = useParams();

  return (
    <PeopleLayout
      {...props}
      header={<NewsHeader />}
      content={<NewsPost id={id} />}
    />
  );
}

function NewsPost({ id }) {
  const [news, setNews] = useState();
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      setNews(await Confluence.item(id));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="row">
      <div className="col-8 news-content">
        <Card className="mb-4">
          <LoadingAnimation loading={loading} />

          {news && (
            <>
              <div className="news-image" style={{ backgroundImage: `url(${news.image})` }}>
                <h1>{news.title}</h1>
              </div>

              <Card.Body>
                <SafeHtml html={news.content} />
              </Card.Body>
            </>
          )}
        </Card>
      </div>

      <div className="col-4 news-sidebar">
        <DataTable
          url="/resource/confluence/posts?limit=10"
          title="Latest news"
          renderRow={(item) => (
            <tr>
              <td style={{ width: 1 }}><img src={item.image} alt={item.title} style={{ width: '60px', maxHeight: '60px' }} /></td>
              <td style={{ fontSize: '1.2em' }}>
                <a href={`/news/${item.id}`}>{item.title}</a>
              </td>
            </tr>
          )}
        />
      </div>
    </div>
  );
}

function NewsHeader() {
  return (
    <div className="feature-header" />
  );
}

export default News;
